import { Spin, Table } from 'antd';
import React, { useEffect, useState } from 'react';
import { styled } from 'styled-components';
import TableActionButton from '../../ui/TableActionButton';
import Title from '../../ui/Title';
import { useDispatch, useSelector } from 'react-redux';
import { deleteNCD, fetchNcdDataList } from '../../../store/slices/ncd-data-slice';
import ConfirmDialog from '../../ui/ConfirmDialog';
import TightWrapper from '../../ui/TightWrapper';
import LoadingError from '../../ui/error/LoadingError';

const NCDTable = () => {
    const dispatch = useDispatch();
    const { isLoading, data, isError } = useSelector((state) => state.ncdData);
    const [dataSource, setDataSource] = useState([]);

    let nullColumns = [];
    if(dataSource.length) {
      nullColumns = Object.keys(dataSource[0]).filter(key => dataSource.every(item => item[key] === null))
    }

    useEffect(() => {
      dispatch(fetchNcdDataList());
    }, []);
    
    useEffect(() => {
      if(data.length >= 0) {
        setDataSource(
          data.map((item) => ({
            ...item,
            key: item.ID,
            delete_id: item.ID,
          }))
          );
        }
    }, [data]);
      
    const columns = [
      {
        title: 'Delete',
        dataIndex: 'delete_id',
        key: 'delete_id',
        render: (_, {delete_id}) => (
          <ConfirmDialog
              onConfirm={() => dispatch(deleteNCD({ id: delete_id }))}
            >
            <TightWrapper>
              <TableActionButton bg='#ff6b6b' >Delete</TableActionButton>
            </TightWrapper>
          </ConfirmDialog>
        )
      },
      {
        title: 'Issuer',
        dataIndex: 'ISSUER',
        key: 'ISSUER',
      },
      {
        title: 'Security Name',
        dataIndex: 'SECURITY_NAME',
        key: 'SECURITY_NAME',
      },
      {
        title: 'Instrument Type',
        dataIndex: 'TYPE_OF_INSTRUMENT',
        key: 'TYPE_OF_INSTRUMENT',
      },
      {
        title: 'Instrument Nature',
        dataIndex: 'NATURE_OF_INSTRUMENT',
        key: 'NATURE_OF_INSTRUMENT',
      },
      {
        title: 'Seniority',
        dataIndex: 'SENIORITY',
        key: 'SENIORITY',
      },
      {
        title: 'Mode of issue',
        dataIndex: 'MODE_OF_ISSUE',
        key: 'MODE_OF_ISSUE',
      },
      {
        title: 'Rating',
        dataIndex: 'RATING',
        key: 'RATING',
      },
      {
        title: 'Issue size',
        dataIndex: 'ISSUE_SIZE',
        key: 'ISSUE_SIZE',
      },
      {
        title: 'Coupon rate',
        dataIndex: 'COUPON_RATE',
        key: 'COUPON_RATE',
      },
      {
        title: 'Coupon payment frequency',
        dataIndex: 'COUPON_PAYMENT_FREQUENCY',
        key: 'COUPON_PAYMENT_FREQUENCY',
      },
      {
        title: 'Coupon Payment Dates',
        dataIndex: 'Coupon_Payment_Dates',
        key: 'Coupon_Payment_Dates',
      },
      {
        title: 'Daily count basis',
        dataIndex: 'DAY_COUNT_BASIS',
        key: 'DAY_COUNT_BASIS',
      },
      {
        title: 'Deemed date of allotment',
        dataIndex: 'DEEMED_DATE_OF_ALLOTMENT',
        key: 'DEEMED_DATE_OF_ALLOTMENT',
      },
      {
        title: 'Redemption date',
        dataIndex: 'REDEMPTION_DATE',
        key: 'REDEMPTION_DATE',
      },
      {
        title: 'Redemption amount',
        dataIndex: 'REDEMPTION_AMOUNT',
        key: 'REDEMPTION_AMOUNT',
      },
      {
        title: 'Put Option date',
        dataIndex: 'PUT_OPTION_DATE',
        key: 'PUT_OPTION_DATE',
      },
      {
        title: 'Call Option date',
        dataIndex: 'CALL_OPTION_DATE',
        key: 'CALL_OPTION_DATE',
      },
      {
        title: 'Face value',
        dataIndex: 'FACE_VALUE',
        key: 'FACE_VALUE',
      },
      {
        title: 'Step up',
        dataIndex: 'STEP_UP',
        key: 'STEP_UP',
      },
      {
        title: 'Step down',
        dataIndex: 'STEP_DOWN',
        key: 'STEP_DOWN',
      },
      {
          title: 'Updated On',
          dataIndex: 'addedOn',
          key: 'addedOn',
          render: (_, { addedOn }) => addedOn && addedOn.split(' ')[0]
      },
    ].filter((item) => !nullColumns.includes(item.key));;

    if(isLoading) return (
      <Spin
          tip="Loading" 
          size="large" 
          className='loading-spiner'
      />
    );
    if(isError) return <LoadingError />;

    return (
        <Wrapper>
          <Title>NCD Table</Title>
            <div className='card'>
                <Table 
                dataSource={dataSource}
                bordered
                size='medium'
                columns={columns} 
                style={{
                    padding: 0,
                }}
                scroll={{ x: 4500, }}
                pagination={{ position: ['topRight', 'bottomRight'], alignment: 'right' }}
                />
            </div>
        </Wrapper>
    );
}

export default NCDTable;

const Wrapper = styled.div`
    width: 95%;
    margin: auto;
    overflow: auto;
    animation: slide-down 300ms ease-out forwards;
    p {
        color: ${({theme}) => theme.colors.primary};
    }
    .ant-table-tbody {
        border: none;
    }
    .ant-table-thead .ant-table-cell {
        background-color:  ${({theme}) => theme.colors.primary};
        color: white;
        border-radius: 0 !important;
    }
    .card {
        box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
    }
`;

